<template>
  <v-app style="background-image: linear-gradient(-150deg, #e8f5e9, #e3f2fd);">
   <v-container>
    <v-card class="form-container elevation-5">
        <v-container>
            <v-card style="background-image: linear-gradient(#5df5a5, #2d93ea);background-size:cover;height:auto">
                <v-layout row wrap style="padding-top:30px">
                    <v-flex xs12 style="text-align: center">
                       <v-avatar :size="90" style="border: 2px solid;border-color:white">
                           <img v-if="form.src != null"
                               :src=form.src
                             >
                             <img v-if="form.src == null"
                               src="../../assets/person.jpg"
                             >
                        </v-avatar>
                    </v-flex>
                    <v-flex xs12 style="text-align: center;padding-top:10px">
                        <h2 class="white--text">{{form.fullName.toUpperCase()}}</h2>
                        <span style="font-size:12px" class="white--text">{{form.userType.toUpperCase()}}</span>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-container>

      <v-card-title>
       <v-container>
        <v-layout row wrap style="margin-top:-25px">
            <v-flex xs12 sm12 md6 style="padding-right:5px">
                <v-text-field readonly v-model="form.mobileNumber" label="Mobile number"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md6>
                <v-text-field readonly v-model="form.email" label="Email ID"></v-text-field>
            </v-flex>

            <v-flex xs12 sm12 md12>
                <v-text-field readonly v-model="form.address" label="Address"></v-text-field>
            </v-flex>
            <v-flex xs12 style="text-align:right">
                <v-btn color="primary" dark @click="edit(form)">
                    <v-icon :size="15" color="white">create</v-icon>&nbsp;Edit</v-btn>
            </v-flex>
        </v-layout>
        </v-container>
      </v-card-title>
    </v-card>
    </v-container>
  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Rooms",
          disabled: true,
          to: "/roomCategory"
        }
      ],
      name: "Sk Majid Ali",
      room: [],
      form: {
      },
      search: "",
      roomCategoryTableHeader: [
        { text: "#", value: "index" },
        { text: "Hotel name", value: "hotelName" },
        { text: "Room Category Name", value: "roomCategoryName" },
        { text: "Total rooms", value: "totalRoom" },
        { text: "Action", value: "action" }
      ]
    };
  },

  methods: {
    getData() {
      this.axios
        .get(config.API + "Admin/" + sessionStorage.loggedInUserID, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.form = res.data;
          this.$Progress.finish();
          this.getData();
        })
        .catch(err => {
          console.log(err.message);
          this.$Progress.fail();
        });
    },

    edit(form) {
      this.$router.push(`editMyProfile/${form.id}`);
    },

    onView(item) {
      this.$router.push(`viewRoom/${item.id}`);
    }
  },

  mounted() {
    this.getData();
    this.$Progress.start();
  }
};
</script>
<style lang="css" scoped>
.bckclr {
  -webkit-text-fill-color:cornflowerblue
}
.txt_dec:hover {
    text-decoration: none !important;
}
</style>